import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Writing from './pages/Writing';
import Projects from './pages/components/Portfolio/Projects';
import Favorites from './pages/Favorites';
import ProtectedRoute from './pages/components/ProtectedRoute';
import MatchaPage from './pages/components/Portfolio/Jessica/MatchaProject/MatchaPage';
import ProjectPage from './pages/components/Portfolio/projectPage';


const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectPage />} />

      <Route path="/writing"element={<Writing />}> 
      </Route>
      <Route
        path="/favorites"
        element={
          <ProtectedRoute password="jessica">
            <Favorites />
          </ProtectedRoute>
        }
      />
      <Route path="/jessica" element={<MatchaPage />}> 
      </Route>
    </Routes>
  );
};

export default App;

